<template>
  <div class="upload-button">
    <label v-text="name" :style="{ color: labelColor }"></label>
    <span style="color: red" v-show="required">*Required</span><br />
    <button class="maf-button upload" disabled="disabled" v-show="uploading">
      Uploading...
    </button>
    <label class="maf-button upload" v-show="!uploading">
      Browse
      <input
        id="fileupload"
        type="file"
        ref="fileInput"
        @change="handleChange"
        @click="checkBeforeBrowse"
        style="display: none;"
      />
    </label>
    <div class="uploaded-docs">
      <table class="uploaded-table" v-show="uploadedFiles && uploadedFiles.length !== 0">
        <thead>
          <tr>
            <td
              style="color: #1de9b6;"
              :style="{ color: hasFiles ? '#1de9b6' : '#6F737A' }"
              colspan="4"
              v-show="hasFiles"
            >
              Your uploaded files
            </td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(file, index) in uploadedFiles"
            :key="index"
          >
            <td>
              <svg
                width="18px"
                height="13px"
                viewBox="0 0 18 13"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    transform="translate(-217.000000, -604.000000)"
                    fill="url(#greenColor)"
                    fill-rule="nonzero"
                    stroke="url(#greenColor"
                    stroke-width="1.014"
                  >
                    <g transform="translate(218.000000, 604.000000)">
                      <g>
                        <g>
                          <path
                            d="M5.41828255,12 C5.15235457,12 4.90858726,11.9154659 4.70914127,11.7252642 L0.299168975,7.5196926 C-0.0997229917,7.13928915 -0.0997229917,6.54755043 0.299168975,6.16714697 C0.698060942,5.78674352 1.31855956,5.78674352 1.71745152,6.16714697 L5.44044321,9.69644573 L14.2825485,1.28530259 C14.6814404,0.904899135 15.3019391,0.904899135 15.700831,1.28530259 C16.099723,1.66570605 16.099723,2.25744476 15.700831,2.63784822 L6.14958449,11.7252642 C5.92797784,11.9154659 5.68421053,12 5.41828255,12 Z"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </td>
            <td><span class="notranslate" v-text="file.name"></span></td>
            <td>
              <a
                href="javascript:void(0)"
                style="color: #D0021B;"
                @click="deleteFile(file)"
                >Delete</a
              >
            </td>
          </tr>
        </tbody>
      </table>
      <div class="uploaded-tip" v-show="!hasFiles">
        Looks like you don’t have any documents yet
      </div>
    </div>
    <div class="error-msg" style="padding-top: 20px" v-show="hasError">
      <p v-if="errorMessage" v-text="errorMessage"></p>
    </div>
  </div>
</template>

<script>
import { uploadFileToFile } from '../../api';
export default {
  name: 'MafFileUpload',
  props: {
    sessionId: {
      type: String,
      default() {
        return '';
      }
    },
    appId: {
      type: String,
      default() {
        return '';
      }
    },
    name: {
      type: String,
      default() {
        return '';
      }
    },
    filePrefix: {
      type: String,
      default() {
        return '';
      }
    },
    fileIndex: {
      type: Number,
      default() {
        return 0;
      }
    },
    hasType: {
      type: Boolean,
      default() {
        return false;
      }
    },
    hasFiles: {
      type: Boolean,
      default() {
        return false;
      }
    },
    uploadedFiles: {
      type: Array,
      default() {
        return [];
      }
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    window.addEventListener('storage', this.handleAuthChange);
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleAuthChange);
  },
  watch: {
    hasType() {
      this.hasError = false;
      this.errorMessage = '';
    },
    uploading() {
      this.$parent.uploading = this.uploading;
      if (this.uploading) {
        this.hasError = false;
        this.errorMessage = '';
      }
    }
  },
  computed: {
    labelColor() {
      return this.hasFiles ? '#393C40' : '#878787';
    }
  },
  data() {
    return {
      fileName: '',
      currentIndex: 0,
      hasError: false,
      errorMessage: '',
      uploading: false,
      maxFileSize: 4508877,
      uploadWidth: 335
    };
  },
  methods: {
    deleteFile(file) {
      this.$parent.deleteFile(file);
    },
    readFile(file) {
      let reader = new FileReader();
      reader.readAsBinaryString(file);

      let self = this;
      if (self.currentIndex < 1) {
        self.currentIndex = self.fileIndex;
      }
      self.fileName =
        self.filePrefix +
        self.currentIndex +
        '.' +
        file.name.replace(/^.+\./, '');
      reader.onload = e => {
        let params = {
          appId: self.appId,
          fileName: self.fileName,
          fileBody: window.btoa(e.target.result)
        };

        self.uploadFileToFile(JSON.stringify(params));
      };

      reader.onerror = () => {
        this.uploading = false;
        this.hasError = true;
        this.errorMessage =
          'Oops! Looks like your file didn’t upload. Please check your connection and try again.';
      };
    },

    async uploadFileToFile(params) {
      let self = this;
      self.uploading = true;
      try {
        const res = await uploadFileToFile(params);
        const uploadedWrapper = JSON.parse(res.replaceAll('&quot;', '"'));
        if (uploadedWrapper.code === 'SUCCESS') {
          self.currentIndex++;
          self.$parent.handleResult(uploadedWrapper.id, self.fileName);
          self.hasError = false;
          self.$el.querySelector('input').value = null;
        } else {
          self.hasError = true;
          self.errorMessage =
            uploadedWrapper.message ||
            'Oops! Looks like your file didn’t upload. Please check your connection and try again.';
        }
      } catch (err) {
        console.error('Upload error', err);
        self.hasError = true;
        self.errorMessage =
          'Oops! Looks like your file didn’t upload. Please check your internet connection.';
      } finally {
        self.uploading = false;
      }
    },
    checkFile(file, event) {
      const maxSizeInMB = (this.maxFileSize / (1024 * 1024)).toFixed(1);
      if (!this.hasType || file.size > this.maxFileSize) {
        this.hasError = true;
        this.errorMessage = !this.hasType
          ? 'You must choose a file type.'
          : `Oops! Looks like your file is too big. Please limit attachments to ${maxSizeInMB} MB.`;
        event.target.value = '';
      } else {
        this.hasError = false;
        this.errorMessage = '';
        this.readFile(file);
      }
    },
    async handleChange(event) {
      if (event.target.files.length > 0) {
        this.checkFile(event.target.files[0], event);
      }
    },
    checkBeforeBrowse(event) {
      const authStatus = localStorage.getItem('authStatus');
      if (authStatus === 'logout') {
        this.hasError = true;
        this.errorMessage =
          'Oops! Looks like your file didn’t upload. Please make sure you are still logged in.';
        event.preventDefault();
        return;
      }

      if (!this.hasType) {
        this.hasError = true;
        this.errorMessage = 'You must choose a file type.';
        event.preventDefault();
        return;
      }

      if (!navigator.onLine) {
        this.hasError = true;
        this.errorMessage =
          'Oops! Looks like your file didn’t upload. Please check your internet connection and try again.';
        event.preventDefault();
      } else {
        this.hasError = false;
        this.errorMessage = '';
      }
    },
    handleAuthChange(event) {
      if (event.key === 'authStatus' && event.newValue === 'logout') {
        this.hasError = true;
        this.errorMessage =
          'Oops! Looks like your file didn’t upload. Please make sure you are still logged in.';
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "./../../sass/flex-layout.scss";
.upload-container {
  position: relative;
  width: 350px;
  height: 220px;
}

.upload-process-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 10px 0 0 10px;
  background-image: linear-gradient(225deg, #1DE9B6 0%, #1DC4E9 100%);
  transition: width 1s;
}

.upload-box {
  position: absolute;
  top: 0;
  left: 180px;
  padding: 21px 0 23px 0;
  width: 350px;
  height: 176px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}

.upload-box .upload-icon {
  width: 56px;
  height: 43px;
}

.maf-button {
  color: #fff;
  border: none;
  border-radius: 100px;
  font-size: 16px;
  padding: 9px 10px;
  min-width: 150px;
  background-repeat: no-repeat;
  outline: none;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  text-align: center;
  line-height: 20px;
}

.maf-button.upload {
  width: 156px;
  margin: 20px 0px;
  background-image: linear-gradient(225deg, #1DE9B6 0%, #1DC4E9 100%);
}

.upload-label {
  font-size: 18px;
  color: #878787;
}

.uploaded-table {
  width: 682px;
}

.uploaded-table thead td {
  text-transform: uppercase;
  font-size: 18px;
  color: #1de9b6;
  letter-spacing: 0.21px;
  font-family: San Francisco Weight;
  padding-bottom: 25px;
}

.uploaded-table tbody td {
  font-size: 14px;
  color: #393c40;
  letter-spacing: 0.17px;
  padding-bottom: 12px;
}

.uploaded-table tbody tr:last-child td {
  padding-bottom: 0;
}

.uploaded-tip {
  width: 390px;
  font-size: 18px;
  color: #878787;
}

@media screen and (max-width: 768px) {
  .uploaded-table {
    width: 100%;
  }

  .uploaded-tip {
    width: 100%;
  }
}

@media screen and (max-width: 500px) {
  .uploaded-tip {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/MafFileUpload.vue